module.exports = __webpack_public_path__ + "static/media/play_new.c65ab6a8.svg";